import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import usePark from "common/hooks/usePark";
// import { Specy } from "types/Specy";

const processOptions = (options: any[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function SuperFamilySelect(props: any) {
  const { park } = usePark();

  return (
    <RemoteSelect
      url="superfamilies"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default SuperFamilySelect;
